export default __webpack_public_path__ + "static/media/leaf3.271f44f4.svg";